import { createAction } from "redux-actions";
import { FETCH_CUSTOMER } from "../constants";
import { serverFindId } from "./../services";
import { urlCustomers } from "./../services/urls";



export const getCustomerData = createAction(FETCH_CUSTOMER, (id) => serverFindId(id, urlCustomers)())
// export const loginSuccess = createAction(LOGIN_SUCCESS, () => ServerGetData(urlUsers)())
